import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useStaticQuery, graphql } from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout";

const NotFoundPage = () => {

    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    pagenotfound
                }
            }
        }
    `);

    const notFoundText = site?.siteMetadata?.pagenotfound;

    return (
        <Layout>
            <div className="layout-padding-top"></div>
            <div className="grey-bg">
                <div className="error-page-wrapper d-flex align-items-center">
                <Container>
                    <Row className="d-flex justify-content-center">
                        <Col xl={7} className="text-center">
                            <h1><span>Something’s</span> gone wrong!</h1>
                            <p>{notFoundText}</p>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <Link to="/" className="button button-primary">Homepage</Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link to="/contact/" className="button button-primary">Contact us</Link>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
                </div>
            </div>
        </Layout>
    )
}

export const Head = () => <Seo title="404: Not Found" />

export default NotFoundPage